module.exports = __webpack_public_path__ + "img/vip-executive-entrecampos-hotel-conference.8bab7982.jpg";